import HotWorkCategoryTwoOptions from "../../../permits/EnergyHarbourPermit/HotWorkCategoryTwoOptions";
import FormElement, { formElement } from "../../FormElement";

type HotWorkCategoryTwoOptionsFormState = {
    screwDriverDrill: FormElement<boolean>;
    openEquipment: FormElement<boolean>;
    multimeter: FormElement<boolean>;
    megger: FormElement<boolean>;
    excavator: FormElement<boolean>;
    exCamera: FormElement<boolean>;
    GPS: FormElement<boolean>;
    totalStation: FormElement<boolean>;
    other: FormElement<string>;
    tigersaw: FormElement<boolean>;
    circularSaw: FormElement<boolean>;
    sparkFreeGrindingWheel: FormElement<boolean>;
    fiberWelding: FormElement<boolean>;
};

export default HotWorkCategoryTwoOptionsFormState;

export function HotWorkCategoryTwoOptionsFormState_default(): HotWorkCategoryTwoOptionsFormState {
    return {
        exCamera: formElement(false),
        excavator: formElement(false),
        GPS: formElement(false),
        megger: formElement(false),
        multimeter: formElement(false),
        openEquipment: formElement(false),
        other: formElement(""),
        screwDriverDrill: formElement(false),
        totalStation: formElement(false),
        tigersaw: formElement(false),
        circularSaw: formElement(false),
        fiberWelding: formElement(false),
        sparkFreeGrindingWheel: formElement(false)
    };
}

export function HotWorkCategoryTwoOptionsFormState_fromFormState(
    formState: HotWorkCategoryTwoOptionsFormState
): HotWorkCategoryTwoOptions {
    return {
        version: undefined,
        screwDriverDrill: formState.screwDriverDrill.value,
        openEquipment: formState.openEquipment.value,
        multimeter: formState.multimeter.value,
        megger: formState.megger.value,
        excavator: formState.excavator.value,
        exCamera: formState.exCamera.value,
        GPS: formState.GPS.value,
        totalStation: formState.totalStation.value,
        other: formState.other.value,
        circularSaw: formState.circularSaw.value,
        tigersaw: formState.tigersaw.value,
        fiberWelding: formState.fiberWelding.value,
        sparkFreeGrindingWheel: formState.sparkFreeGrindingWheel.value
    };
}
